import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const OriginalResizeObserver2 = window.ResizeObserver;
Object.defineProperty(window, 'ResizeObserver', {
    writable: true,
    configurable: true,
    value: class ResizeObserver extends OriginalResizeObserver2 {
        constructor(callback) {
            super((entries, observer) => {
                console.log('ResizeObserver entries:', entries.map(e => e.target));
                window.requestAnimationFrame(() => {
                    callback(entries, observer);
                });
            });
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <App />
);
